// extracted by mini-css-extract-plugin
export var grey = "GroupedContent-module--grey--it3al";
export var lightBlue = "GroupedContent-module--light-blue--3gRDj";
export var white = "GroupedContent-module--white--2sOuF";
export var accordion = "GroupedContent-module--accordion--2m44I";
export var largeCardsHeading = "GroupedContent-module--large-cards-heading--efpl3";
export var grid = "GroupedContent-module--grid--3Psq-";
export var profileGrid = "GroupedContent-module--profile-grid--1nfVc";
export var profiles = "GroupedContent-module--profiles--QDUsi";